import ajax from './ajax'

// 1. 基础路径
//const BASE_URL = '/api';  // 防跨域
// const UNI_URL = 'http://localhost:8181';  // 服务器真实地址
// const SALE_URL = 'http://localhost:8282';
// const BASIC_URL = 'http://localhost:8080';
// const BASIC_URL = 'http://testcrm.lightcourse.com/prod-api';
// const STU_URL = 'http://localhost:8383';
const UNI_URL = 'https://crm.lightcourse.com/prod-api';  // 服务器真实地址
const SALE_URL = 'https://crm.lightcourse.com/prod-api';
const BASIC_URL = 'https://crm.lightcourse.com/prod-api';
const STU_URL = 'https://crm.lightcourse.com/prod-api';
// 2. 请求方法

export const getCategory = () => ajax(UNI_URL + '/wxcall/university/category/list');
export const getCategoryTree = () => ajax(UNI_URL + '/wxcall/university/category/search');

export const getCategoryCourse = () => ajax(UNI_URL + '/wxcall/university/api/category/listCourse');

export const getIndexCourse = () => ajax(UNI_URL + '/wxcall/university/api/course/indexCourse');

export const submitRequire = (params) => ajax(UNI_URL + '/wxcall/university/api/notify/stuRequire', params, "POST");

export const getCourseUni = () => ajax(UNI_URL + '/wxcall/university/api/courseUni');
export const selectUni = (params) => ajax(UNI_URL + '/wxcall/university/uni/search', params); //按学校名称 缩写查询学校列表
export const selectCourse = (params) => ajax(UNI_URL + '/wxcall/university/course/search', params); //查询课程列表

export const getCourseCount = (params) => ajax(UNI_URL + '/wxcall/university/course/item/search/count', params);

export const getCourseList = (params) => ajax(UNI_URL + '/wxcall/university/course/item/search', params);

export const getCourseCount2 = (params) => ajax(UNI_URL + '/wxcall/university/course/item/search2/count', params,"POST");

export const getCourseList2 = (params) => ajax(UNI_URL + '/wxcall/university/course/item/search2?pageSize='+params.pageSize+"&pageNum="+params.pageNum+"&orderByColumn="+params.orderByColumn+"&isAsc="+params.isAsc, params,"POST");

export const getCourseCount3 = (params) => ajax(UNI_URL + '/wxcall/university/course/item/search3/count', params,"POST");

export const getCourseList3 = (params) => ajax(UNI_URL + '/wxcall/university/course/item/search3?pageSize='+params.pageSize+"&pageNum="+params.pageNum+"&orderByColumn="+params.orderByColumn+"&isAsc="+params.isAsc, params,"POST");


export const getCourseDetail = (params) => ajax(UNI_URL + '/wxcall/university/course/saleitem/' + params.itemId +"/" + params.courseId+"/null");

export const getBlogList = (params) => ajax(SALE_URL + '/wxcall/market/config/blogList', params);

export const getBlogDetail = (params) => ajax(SALE_URL + '/wxcall/market/config/blogDetail', params);

export const getPayDetail = (params) => ajax(SALE_URL + '/wxcall/market/pay/getPayDetail?payNo=' + params.payNo, "", "POST");

export const getPayConfig = () => ajax(SALE_URL + '/wxcall/market/pay/Config');

export const wxH5PrePay = (params) => ajax(BASIC_URL + '/wxcall/common/wx/h5/prePay', params, "POST");

export const getUniMappingTempDetail = (params) => ajax(SALE_URL + '/wxcall/market/getUniMappingTempDetail',params);

export const authH5toApplet = (params) => ajax(STU_URL + '/wxcall/student/auth/authH5toApplet',params,"POST");

export const getJsapiSignature = (params) => ajax(STU_URL + '/wxcall/student/auth/getJsapiSignatureH5',params,"POST");
export const getAgentConfigTicket = (params) => ajax(STU_URL + '/wxcall/student/auth/getAgentConfigTicket',params,"POST");

export const webAuth = (params) => ajax(BASIC_URL + '/wxcall/common/wx/h5/oauth2/access_token?code='+params.code,params,"POST");

export const recordStuOper = (params) => ajax(STU_URL + '/wxcall/student/api/recordStudentOper',params,"POST");

export const getNearYearQuarter = () => ajax(UNI_URL + '/wxcall/university/getNearYearQuarter');

export const queryHisGrade = (params) => ajax(STU_URL + '/wxcall/student/api/queryHisGrade',params,"POST");

export const getAreaCache = (params) => ajax(BASIC_URL + '/wxcall/common/api/getAreaCache',params,);

export const getDictList = (params) => ajax(BASIC_URL + '/wxcall/common/api/type/'+params.type);




// WEBPACK FOOTER //
// ./src/api/course.js